"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MobileAppAPI {
    client;
    constructor(client) {
        this.client = client;
    }
    async getBrandApp(brandId) {
        const apps = await this.client.get(`/mobile-apps`, { brandId });
        return apps.total > 0 ? apps.results[0] : null;
    }
    async listAllApps(filter) {
        let page = 1;
        let numPages = null;
        let apps = [];
        while (numPages === null || page <= numPages) {
            const { results, pageCount } = await this.client.get(`/mobile-apps`, {
                ...filter,
                page,
                limit: 100,
            });
            numPages = pageCount;
            apps = apps.concat(results);
            page += 1;
            // break if there are no pages
            if (!numPages) {
                break;
            }
        }
        return apps;
    }
    async listAllDeployments(filter) {
        let page = 1;
        let numPages = null;
        let apps = [];
        while (numPages === null || page <= numPages) {
            const { results, pageCount } = await this.client.get(`/mobile-apps/deployments`, {
                ...filter,
                page,
                limit: 100,
            });
            numPages = pageCount;
            apps = apps.concat(results);
            page += 1;
            // break if there are no pages
            if (!numPages) {
                break;
            }
        }
        return apps;
    }
    async getDeployment(deploymentId) {
        const deployment = await this.client.get(`/mobile-apps/deployments/${deploymentId}`);
        return deployment;
    }
    async updateDeployment(deploymentId, update) {
        const deployment = await this.client.patch(`/mobile-apps/deployments/${deploymentId}`, update);
        return deployment;
    }
    async createDeployment(params) {
        const deployment = await this.client.post(`/mobile-apps/deployments`, params);
        return deployment;
    }
}
exports.default = MobileAppAPI;
//# sourceMappingURL=index.js.map